module.exports = __webpack_public_path__ + "static/media/parts_18.235ad3f6.svg";